import React, { useMemo } from "react";
import "./TopCard.css";
import { useSelector } from "react-redux";

const fmt = require("indian-number-format");

export default function TopCard(props) {
  const total = useSelector((state) => state.total);
  const safeNum = (val) => parseFloat(val ?? 0).toFixed(0);

  const exchanges = useMemo(
    () => [
      {
        key: "TOTAL",
        label: "TOTAL",
        active: true,
        buy: props.buy,
        sell: props.sell,
        total: props.total,
      },
      {
        key: "NSE",
        label: "NSE-FUTURE",
        active: props.nse === 1,
        buy: props.nsebuy,
        sell: props.nsesell,
        total: props.nse,
      },
      {
        key: "NSECASH",
        label: "NSE-EQUITY",
        active: props.nsecash === 1,
        buy: props.nsecashbuy,
        sell: props.nsecashsell,
        total: props.nsecash,
      },
      {
        key: "MCX",
        label: "MCX-FUTURE",
        active: props.mcx === 1,
        buy: props.mcxbuy,
        sell: props.mcxsell,
        total: props.mcx,
      },
      {
        key: "OPTIONS",
        label: "NSE-OPTIONS",
        active: props.options === 1,
        buy: props.optionsbuy,
        sell: props.optionssell,
        total: props.options,
      },
      {
        key: "COMEX",
        label: "COMEX",
        active: props.comex === 1,
        buy: props.comexbuy,
        sell: props.comexsell,
        total: props.comex,
      },
      {
        key: "CRYPTO",
        label: "CRYPTO",
        active: props.crypto === 1,
        buy: props.cryptobuy,
        sell: props.cryptosell,
        total: props.crypto,
      },
      {
        key: "FOREX",
        label: "FOREX",
        active: props.forex === 1,
        buy: props.forexbuy,
        sell: props.forexsell,
        total: props.forex,
      },
    ],
    [props]
  );

  return (
    <div className="HoldingContainer small">
      {/* Profit / Loss */}
      <div className="ProfitBox">
        <span className="title">P&L</span>
        <span className={`value ${total >= 0 ? "buytext" : "selltext"}`}>
          {fmt.format(total)}
        </span>
      </div>

      {/* Exchange Cards */}
      <div className="CardRow">
        {exchanges
          .filter((ex) => ex.active)
          .map((ex) => (
            <div
              key={ex.key}
              onClick={() => props.FilterExchange(ex.key)}
              className="MiniCard"
            >
              <div className="line smalltext">
                <span className="buytext">B:</span>
                <span>{fmt.format(safeNum(ex.buy))}</span>
              </div>
              <div className="line midlabel">{ex.label}</div>
              <div className="line smalltext">
                <span className="selltext">S:</span>
                <span>{fmt.format(safeNum(ex.sell))}</span>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
